<sim-basic-material-dialog
	(closeClicked)="close({action: 'close'})"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-door-open'}"
	[headerText]="data.trainingRoom?.name"
	class="normalDuotoneHeaderIcon"
>
	@if (hasLicenseModule(Modules.EnableRoomLayoutSwitcher)) {
		<span headerActions>
			<sim-room-layout-switcher [(selectedPreset)]="selectedPreset" [trainingRoom]="data.trainingRoom" styling="room-detail" />
		</span>
	}

	<ng-container dialogContent>
		<div class="cameraLayoutContainer">
			@if (data.trainingRoom?.id) {
				<sim-base-camera-layout
					[cameraLayoutOptionsContainer]="{
						optionType: 'Livestream',
						options: {
							screens: data.trainingRoom?.roomLayout?.[selectedPreset]?.cameras,
							cameraViewMode: CameraViewMode.AllScreens,
							trainingRoomId: data.trainingRoom?.id,
							cameraLayoutType: data.trainingRoom?.roomLayout?.[selectedPreset]?.layoutType,
							cameraLayoutOption: data.trainingRoom?.roomLayout?.[selectedPreset]?.layoutOption,
							displayMode: DisplayMode.Auto,
							preferredStream: CameraResolutionType.RecordingWindow,
							preferredFullscreenStream: CameraResolutionType.RecordingWindowFull,
							dragdropEnabled: false,
							enableControl: data.enableControls,
						},
					}"
				/>
			}
		</div>

		@if (mapping) {
			<audio-player
				[trainingRoomId]="data.trainingRoom.id"
				[muteWebsocketAudio]="mapping.muteWebsocketAudio"
				[preferredFrameSize]="mapping?.preferedFrameSize"
				[ringBufferLength]="mapping.ringBufferLength"
				[requestVolumeData]="false"
				[requestLatencyData]="false"
				[audioOutputMuted]="volumeCtrl.value === 0"
				[audioOutputVolume]="volumeCtrl.value"
				[webClient]="mapping"
				[webClientType]="ClientType.WebViewingStation"
				[webClientMasterId]="connectedWebClientId"
				[announcementSessionId]="data.announcementSessionId"
			/>
		}
	</ng-container>

	<ng-container actions>
		@if (mapping) {
			<div class="volumeControls">
				<button
					*ngVar="volumeCtrl.value === 0 as isMuted"
					mat-icon-button
					(click)="volumeCtrl.setValue(isMuted ? previousVolumeValue : 0)"
					[color]="isMuted ? 'warn' : 'accent'"
				>
					<i
						(click)="volumeCtrl.setValue(previousVolumeValue)"
						[ngClass]="{
							'fa-volume-slash': isMuted,
							'fa-volume-up': volumeCtrl.value > 60,
							'fa-volume': volumeCtrl.value <= 60 && volumeCtrl.value >= 30,
							'fa-volume-down': volumeCtrl.value < 30,
						}"
						class="far volumeIcon"
					></i>
				</button>
				<mat-slider max="100" min="0" discrete color="accent">
					<input [formControl]="volumeCtrl" matSliderThumb />
				</mat-slider>
			</div>
		}
		<sim-button [label]="T.BUTTON_CLOSE" [icon]="{fontIcon: 'fa-check', fontSet: 'far'}" (onClick)="close({action: 'close'})" />
	</ng-container>
</sim-basic-material-dialog>
